import React from "react";
import { Link } from "react-router-dom";

// Official DRS 2026 logo (provided by the client).
const Logo = ({ className = "" }) => {
  return (
    <Link to="/" className={`inline-flex items-center ${className}`} aria-label="DRS 2026 Home">
      <img
        src="/brand/drs_header.png"
        alt="DRS 2026 — Diabetes Research & Solutions"
        className="h-11 md:h-12 w-auto object-contain"
      />
    </Link>
  );
};

export default Logo;
